/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { deleteCourse, getInstructorCourses } from '../../../../../services/operations/courseApi';
import { IoMdAddCircleOutline } from 'react-icons/io';
import Loading from '../../../../../pages/Loading';
import { formattedDate } from '../../../../../utils/dateFormatter';
import { COURSE_STATUS } from '../../../../../utils/constants';
import { MdDelete, MdOutlineDownloadDone, MdWatchLater } from 'react-icons/md';
import { BiEdit, BiRupee } from 'react-icons/bi';
import ConfirmationModal from '../../../../common/ConfirmationModal';
import { useDispatch, useSelector } from 'react-redux';
import { courseDuration } from '../../../../../utils/courseDurationCount';
import { useNavigate } from 'react-router-dom';
import { setBlurLoading } from '../../../../../redux/slices/authSlice';

const MyCourses = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [confirmationModal, setConfirmationModal] = useState(null);
    const [selectAll, setSelectAll] = useState(false);
    const [checkboxes, setCheckboxes] = useState([]);
    const { user } = useSelector((state) => state.profile);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await getInstructorCourses(user._id);
            setCourses(response.data.courses);
            setCheckboxes(new Array(response.data.courses.length).fill(false));
        } catch (error) {
            console.error('Course fetching failed in MyCourses component:', error.message);
        } finally {
            setLoading(false);
        }
    };
    const truncateText = (text, maxLength) => {
        const words = text.split(' ');
        if (words.length > maxLength) {
            return words.slice(0, maxLength).join(' ') + '...';
        }
        return text;
    };
    const deleteCourseHandler = async (courseID) => {
        dispatch(setBlurLoading(true));
        try {
            await deleteCourse(courseID);
            await fetchCourses();
        } catch (error) {
            console.error('Error while deleting course in MyCourses component:', error.message);
        } finally {
            dispatch(setBlurLoading(false));
        }
        setConfirmationModal(null);
    };
    const setConfirmationModalData = (courseID) => {
        setConfirmationModal({
            text1: 'Are you sure?',
            text2: 'You want to proceed with deleting your course. Please keep in mind that this action is irreversible. Once you delete your course, it will be deleted permanently.',
            btn1Text: 'Delete',
            btn2Text: 'Cancel',
            btn1Handler: () => deleteCourseHandler(courseID),
            btn2Handler: () => setConfirmationModal(null),
        });
    };
    const singleSelectHandler = (index, event) => {
        const checked = event.target.checked;
        setCheckboxes((prevCheckboxes) => {
            const updatedCheckboxes = [...prevCheckboxes];
            updatedCheckboxes[index] = checked;
            setSelectAll(updatedCheckboxes.every((checkbox) => checkbox));
            return updatedCheckboxes;
        });
    };
    const allSelectHandler = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);
        setCheckboxes(new Array(courses.length).fill(checked));
    };
    const allCourseDeleteHandler = () => {
        // Temprory Closed This API
    };
    const editCourseHandler = (course) => {
        navigate(`/course/${course?.courseName.toLowerCase()}/${course?._id}/${course?.courseContent[0]?._id}/${course?.courseContent[0]?.subSection[0]?._id}`);
    };
    if (loading) {
        return <Loading />;
    }

    return (
        <div className='text-richblack-5 flex flex-col gap-y-10'>
            <div className='flex items-center justify-between'>
                <header className='text-3xl font-medium'>My Courses</header>
                <button
                    onClick={() => !selectAll ? navigate('/dashboard/new-course') : allCourseDeleteHandler()}
                    className={`font-bold shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] md:text-lg px-6 py-3 rounded-md ${!selectAll ? 'bg-yellow-50 text-black' : 'bg-[#dd2323]'
                        } hover:shadow-transparent hover:scale-95 transition-all duration-200`}
                >
                    <div>
                        {!selectAll ? <span className='flex items-center gap-x-3'>
                            Add Course <IoMdAddCircleOutline className='text-2xl' />
                        </span>
                            : "Delete All"}
                    </div>
                </button>
            </div>
            <div>
                {!courses.length ? (
                    <div className='text-3xl font-medium text-center mt-16'>
                        You have not created any courses yet.
                    </div>
                ) : (
                    <div className='text-xl'>
                        <div className='flex flex-col font-light text-lg border border-richblack-800'>
                            <div className='uppercase border-b border-b-richblack-800 pl-2 py-3 pr-5'>
                                <div className='flex justify-between text-sm text-richblack-200'>
                                    <div className=''>
                                        <div className='checkbox-wrapper-45'>
                                            <input
                                                id='all-select'
                                                type='checkbox'
                                                onChange={allSelectHandler}
                                                checked={selectAll}
                                            />
                                            <label className='cbx' htmlFor='all-select'>
                                                <div className='flip'>
                                                    <div className='front'></div>
                                                    <div className='back'>
                                                        <svg width='15' height='13' viewBox='0 0 16 14'>
                                                            <path d='M2 8.5L6 12.5L14 1.5'></path>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className='font-medium w-[60%] text-start cursor-default'>Courses</div>
                                    <div className='font-medium hidden xl:block w-[18%] text-center cursor-default'>Duration</div>
                                    <div className='font-medium hidden xl:block cursor-default'>Price</div>
                                    <div className='font-medium hidden xl:block cursor-default'>Actions</div>
                                </div>
                            </div>
                            <div>
                                {courses.map((course, index) => (
                                    <div
                                        key={course._id}
                                        className='flex flex-col xl:flex-row border-b border-b-richblack-800 py-5 px-2 justify-between'
                                    >
                                        <div className='flex gap-x-4 xl:w-[63%] w-full'>
                                            <div className='checkbox-wrapper-45 flex md:items-center items-start mt-20 md:mt-0'>
                                                <input
                                                    id={`check-${index}`}
                                                    type='checkbox'
                                                    onChange={(event) => singleSelectHandler(index, event)}
                                                    checked={checkboxes[index]}
                                                />
                                                <label className='cbx' htmlFor={`check-${index}`}>
                                                    <div className='flip'>
                                                        <div className='front'></div>
                                                        <div className='back'>
                                                            <svg width='14' height='12' viewBox='0 0 16 14'>
                                                                <path d='M2 8.5L6 12.5L14 1.5'></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className='flex flex-col md:flex-row md:items-center'>
                                                <img
                                                    src={course?.thumbnail}
                                                    alt={course?.courseName}
                                                    loading='lazy'
                                                    className='md:min-w-[18rem] md:w-[18rem] w-[80%] h-[12rem] rounded-lg bg-cover my-4'
                                                />
                                                <div className='md:mx-4 my-4 xl:w-[60%]'>
                                                    <p className='font-bold'>{course?.courseName}</p>
                                                    <p className='text-sm text-richblack-300 my-3 flex items-center'>
                                                        {truncateText(course?.courseDescription, 20)}
                                                    </p>
                                                    <p className='text-sm font-medium'>
                                                        Created: {formattedDate(course?.createdAt)}
                                                    </p>
                                                    <div className='my-3'>
                                                        {course?.status === COURSE_STATUS.DRAFT ? (
                                                            <p className='text-pink-50 flex w-fit flex-row items-center gap-2 rounded-full bg-richblack-700 px-[9px] leading-5 py-[1px] text-[12px] font-medium'>
                                                                <MdWatchLater />
                                                                DRAFTED
                                                            </p>
                                                        ) : (
                                                            <p className='text-caribbeangreen-300 flex w-fit flex-row items-center gap-2 rounded-full bg-richblack-700 px-[9px] leading-5 py-[1px] text-[12px] font-medium'>
                                                                <MdOutlineDownloadDone />
                                                                PUBLISHED
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='text-[16px] xl:w-[18%] xl:text-center text-richblack-50 my-2 xl:block flex flex-wrap items-center gap-x-3 xl:ml-0 ml-9'>
                                            <span className='uppercase text-richblack-200 text-sm font-medium block xl:hidden cursor-default'>
                                                Duration :
                                            </span>
                                            <span className='cursor-default'>
                                                {courseDuration(course?.duration)}
                                            </span>
                                        </div>
                                        <div className='text-[16px] text-richblack-50 my-2 xl:block flex items-center gap-x-3 xl:ml-0 ml-9'>
                                            <span className='uppercase text-richblack-200 text-sm font-medium block xl:hidden cursor-default'>
                                                Price :
                                            </span>
                                            <p className='flex items-center cursor-default'>
                                                <BiRupee />
                                                {parseInt(course?.price).toLocaleString()}
                                            </p>
                                        </div>
                                        <div className='text-[16px] text-richblack-50 my-3 xl:block flex items-center gap-x-3 xl:ml-0 ml-9'>
                                            <span className='uppercase text-richblack-200 text-sm font-medium block xl:hidden cursor-default'>
                                                Actions :
                                            </span>
                                            <button
                                                type='button'
                                                className='hover:scale-125 hover:text-caribbeangreen-500 text-xl xl:mx-2 transition-all duration-300'
                                                onClick={() => editCourseHandler(course)}
                                            >
                                                <BiEdit />
                                            </button>
                                            <button
                                                type='button'
                                                className='hover:scale-125 hover:text-pink-500 text-xl xl:mx-2 transition-all duration-300'
                                                onClick={() => setConfirmationModalData(course._id)}
                                            >
                                                <MdDelete />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    );
};

export default MyCourses;